'use client';

// MED-3: fallback de último recurso. O Next só usa este componente quando o
// erro escapou de todos os `error.tsx` aninhados ou foi lançado no próprio
// RootLayout. Por isso precisa renderizar `<html>` e `<body>`.

import { useEffect } from 'react';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('[GlobalError]', error);
    }
  }, [error]);

  return (
    <html lang="pt-BR">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
          background: '#0b0d12',
          color: '#e6e8eb',
        }}
      >
        <div style={{ maxWidth: 480, padding: 24, textAlign: 'center' }}>
          <h1 style={{ fontSize: 24, marginBottom: 12 }}>Erro inesperado na aplicação</h1>
          <p style={{ opacity: 0.75, marginBottom: 24 }}>
            A interface não conseguiu se recuperar. Recarregue a página — se o problema persistir,
            entre em contato com o suporte.
          </p>
          {error.digest && (
            <p style={{ opacity: 0.4, fontSize: 12, marginBottom: 24 }}>ref: {error.digest}</p>
          )}
          <button
            onClick={() => reset()}
            style={{
              padding: '12px 24px',
              borderRadius: 8,
              border: 'none',
              background: '#2563eb',
              color: 'white',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Recarregar
          </button>
        </div>
      </body>
    </html>
  );
}
